export default function view(state, action) {
  if (action.type === 'SET_VIEW') {
    return {
      ...state,
      view: action.view,
    };
  } else if (action.type === 'ACTIVATE_RESOURCE_SEARCH') {
    return {
      ...state,
      view: 'resources',
    };
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/view.js